import { jsxs as e, Fragment as d, jsx as l } from "react/jsx-runtime";
const C = () => /* @__PURE__ */ e(d, { children: [
  /* @__PURE__ */ l(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.17896 6.08714C8.58421 4.18396 10.006 2.25 12 2.25C13.9939 2.25 15.4158 4.18396 14.821 6.08715L14.1764 8.14992C13.8789 9.10185 12.9973 9.75 12 9.75C11.0027 9.75 10.1211 9.10185 9.82357 8.14992L9.17896 6.08714Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ l(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.0147 15.0439C20.8421 15.8416 21.3714 18.1829 20.0648 19.6892C18.7583 21.1954 16.3657 21.0023 15.3177 19.3059L14.1819 17.4674C13.6577 16.6189 13.7457 15.5282 14.3992 14.7748C15.0527 14.0214 16.12 13.7801 17.0341 14.1792L19.0147 15.0439Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ l(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.05885 19.3589C6.95179 21.0172 4.55387 21.126 3.30119 19.5747C2.04851 18.0234 2.65992 15.7022 4.51427 14.9692L6.52412 14.1748C7.45163 13.8082 8.50977 14.0869 9.13633 14.8629C9.7629 15.6388 9.81249 16.7319 9.25875 17.5614L8.05885 19.3589Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ l(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15Z",
      fill: "currentColor"
    }
  )
] });
export {
  C as default
};
